import React, {useEffect, useState, useRef} from 'react';
import {useAuth} from '../../context/AuthContext';
import {useNavigate} from 'react-router-dom';
import apiClient from '../../context/apiClient';
import EmployeeCard from '../Personal/EmployeeCard';
import NewEmployeeCard from "../Personal/AddCard";

const tabs = [
    {label: 'Instruktoren', key: 'INSTRUCTOR'},
    {label: 'Mechaniker', key: 'MECHANIC'},
    {label: 'Guestmanager', key: 'GUEST_MANAGER'},
];

const Personal = () => {
    const {user} = useAuth();
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);

    const instructorRef = useRef(null);
    const mechanicRef = useRef(null);
    const guestManagerRef = useRef(null);
    const hasFetchedRef = useRef(false);

    // Scroll to a section on tab click
    const scrollToSection = (roleKey) => {
        const refMap = {
            INSTRUCTOR: instructorRef,
            MECHANIC: mechanicRef,
            GUEST_MANAGER: guestManagerRef,
        };
        refMap[roleKey]?.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    // Funktion jetzt im Komponenten-Body definiert
    const fetchEmployees = async () => {
        try {
            const response = await apiClient.get('/api/employee/all', {withCredentials: true});
            setEmployees(response.data);
            console.log('fetched');
        } catch (err) {
            console.error('Fehler beim Laden der Employees', err);
        }
    };

// useEffect bleibt bestehen
    useEffect(() => {
        if (!user || hasFetchedRef.current) return;

        hasFetchedRef.current = true;
        fetchEmployees();
    }, [user, navigate]);


    // Group employees by role
    const sortByLastName = (list) =>
        [...list].sort((a, b) => {
            const lastNameComp = a.lastName.localeCompare(b.lastName, 'de', {sensitivity: 'base'});
            if (lastNameComp !== 0) return lastNameComp;
            return a.firstName.localeCompare(b.firstName, 'de', {sensitivity: 'base'});
        });


    const grouped = {
        INSTRUCTOR: sortByLastName(employees.filter(e => e.role === 'INSTRUCTOR')),
        MECHANIC: sortByLastName(employees.filter(e => e.role === 'MECHANIC')),
        GUEST_MANAGER: sortByLastName(employees.filter(e => e.role === 'GUEST_MANAGER')),
    };


    // Role Tabs component
    const RoleTabs = ({currentTab}) => (
        <div className="flex gap-4 border-b mb-4 text-gray-600 text-sm font-medium">
            {tabs.map(tab => (
                <button
                    key={tab.key}
                    onClick={() => scrollToSection(tab.key)}
                    className={`py-2 px-1 transition ${
                        currentTab === tab.key
                            ? 'border-b-2 border-blue-500 text-gray-900 font-semibold'
                            : 'border-b-2 border-transparent hover:border-gray-300'
                    }`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );

    return (
        <main className="fixed top-16 inset-0 bg-gray-100 overflow-y-auto overflow-x-auto">
            <div className="px-6 py-8">
                {/* Legende */}
                <div className="mb-8 text-sm text-gray-500 flex flex-wrap gap-3 justify-center">
                    <div className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-indigo-500 inline-block"></span> Kursleiter:in
                    </div>
                    <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 rounded-full bg-indigo-100 border border-indigo-300 inline-block"></span> Instruktor:in
                    </div>
                    <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 rounded-full bg-emerald-200 border border-emerald-300 inline-block"></span> Mechaniker:in
                    </div>
                    <div className="flex items-center gap-2">
                    <span
                        className="w-3 h-3 rounded-full bg-rose-200 border border-rose-300 inline-block"></span> Gästebetreuer:in
                    </div>
                </div>

                {/* Instructors */}
                <section ref={instructorRef} className="mb-16">
                    <RoleTabs currentTab="INSTRUCTOR"/>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        <NewEmployeeCard role="INSTRUCTOR" onEmployeeAdded={fetchEmployees}/>
                        {grouped.INSTRUCTOR.map((employee) => (
                            <EmployeeCard key={employee.id} employee={employee} onUpdated={fetchEmployees}/>
                        ))}
                    </div>
                </section>

                {/* Mechanics */}
                <section ref={mechanicRef} className="mb-16">
                    <RoleTabs currentTab="MECHANIC"/>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        <NewEmployeeCard role="MECHANIC" onEmployeeAdded={fetchEmployees}/>
                        {grouped.MECHANIC.map((employee) => (
                            <EmployeeCard key={employee.id} employee={employee} onUpdated={fetchEmployees}/>
                        ))}
                    </div>
                </section>

                {/* Guest Manager */}
                <section ref={guestManagerRef} className="mb-16">
                    <RoleTabs currentTab="GUEST_MANAGER"/>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        <NewEmployeeCard role="GUEST_MANAGER" onEmployeeAdded={fetchEmployees}/>
                        {grouped.GUEST_MANAGER.map((employee) => (
                            <EmployeeCard key={employee.id} employee={employee} onUpdated={fetchEmployees}/>
                        ))}
                    </div>
                </section>
            </div>
        </main>
    );
};

export default Personal;
